import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './component/Hero/Hero';
import SearchPage from './component/search/Search';
import Navbar from './component/Navbar/Navbar';
import AnswerPage from './component/Answer/Answer';
import Signup from './component/Signup/Signup';
import Login from './component/Signup/Login';
import AiSolution from './component/AI/AiSolution';
import Oldpage from './component/AI/oldpage';
import Contact from './component/Contact/Contact';
import SubmitRequest from './component/SubmitRequest/SubmitRequest';

function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/search" element={<SearchPage />} />
         <Route path="/answer/:id" element={<AnswerPage />} />
         <Route path="/signup" element={<Signup/>}/>
         <Route path='/login'element={<Login/>}/>
         <Route path='/ai-solution' element={<AiSolution/>}/>
         <Route path="/old-page"element={<Oldpage/>}/>
         <Route path="/contact" element={<Contact/>}/>
         <Route path="/submit-request" element={<SubmitRequest/>}/>
      </Routes>
    </Router>
  );
}

export default App;
